import {Ticket} from "@/utils";
import i18n from '@/assets/i18n'
import qs from 'qs'

const appConfig = require('@/config');

// 文件下载
export const downloadFile = (url, data) => {
    const token = Ticket.get().access_token;
    const culture = i18n.locale;

    let queryData = {
        access_token: token,
        culture: culture,
        'ui-culture': culture,
        ...data
    }

    let queryString = qs.stringify(queryData, {indices: false})

    let downloadLink = document.createElement('a')
    downloadLink.href = `${appConfig.baseUrl}/${url}?${queryString}`
    downloadLink.download = ''
    downloadLink.click()
}
